import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { MutationOption, queryClient } from "libs/react-query";
import * as KeyFactory from "./activity-query-key-factory";

interface ISetActivityCategoryProps {
  activityId: string;
  category: string;
}

/**
 * Sets category value of an activity
 *
 * @param {string} activityId - uuid of the activity
 * @param {string} category - category value of the activity
 */
export const setActivityCategory = ({ activityId, category }: ISetActivityCategoryProps) => {
  return Brm.activityApi.setActivityCategory(activityId, { body: category });
};

export interface IUseSetActivityCategory {
  options?: MutationOption<typeof setActivityCategory>;
}

/**
 * Custom hook to change the category value of an existing activity
 *
 * @param {object} options - react-query configuration object
 * @returns react-query ReactQuery.useMutation
 */
export const useSetActivityCategory = ({ options }: IUseSetActivityCategory) => {
  return ReactQuery.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(KeyFactory.activitiesKeys.all);
    },
    ...options,
    mutationFn: setActivityCategory,
  });
};
